import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import BaoDialog from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import GenericListTab from "./../../factories/generic-list-tab";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import * as ko from "knockout";
class ConfigurationItem100WorkPeriodTab extends GenericListTab {
    ConfigurationItem: any;
    ControllerUrl = "ConfigurationItem100WorkPeriodTab";
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 800;
        this.ConfigurationItem = parent;
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    Dialog(id: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItem100WorkPeriodTab/Dialog", JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item = ko.map.toJS(dialog.ViewModel());
                Bao.post("ConfigurationItem100WorkPeriodTab/Save", JSON.stringify({
                    sessionTabId: this.SessionTabId,
                    model: item
                }), (resultSave) => {
                    if (!resultSave.Result) {
                        new BaoDialog(Bao.Session.ApplicationName, resultSave.Message, "info");
                    }
                    else {
                        this.Save(item).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                    this.TabPage.IsLoading(false);
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
}
export default ConfigurationItem100WorkPeriodTab;